import { FuncionalidadesGeral } from '../../../helpers/funcionalidades'
import servicosIcon from '../../../images/Servicos.png'
import assuntosIcon from '../../../images/Assuntos.png'
import perguntasIcon from '../../../images/Perguntas.png'
import formularioIcon from '../../../images/Formularios.png'
import secoesIcon from '../../../images/secoes.png'
import dominiosIcon from '../../../images/Dominios.png'
import validacaoRecuperacao from '../../../images/Validacao_Recuperacao.png'
import atendimentoPresencialIcon from '../../../images/atendimento-v.png'
import atendimentoTelefonicoIcon from '../../../images/atendimento-v-presenc.png'

export const options = [
  {
    title: 'Serviços',
    icon: servicosIcon,
    description: 'Cadastre novos serviços e consulte, altere e exclua serviços existentes',
    route: '/consultar-servico-area',
    area: 'formulario',
    funcionalidade: FuncionalidadesGeral.servicos.consultar,
  },
  {
    title: 'Assuntos',
    icon: assuntosIcon,
    description: 'Cadastre novos assuntos e consulte, altere e exclua assuntos existentes',
    route: '/consultar-assunto',
    area: 'formulario',
    funcionalidade: FuncionalidadesGeral.assuntos.consultar,
  },
  {
    title: 'Métodos de Recuperação ou Validação',
    icon: validacaoRecuperacao,
    description: 'Cadastre métodos de recuperação e validação de domínios e respostas.',
    route: '/consultar-metodo',
    area: 'formulario',
    funcionalidade: FuncionalidadesGeral.metodos.consultar,
  },
  {
    title: 'Domínios',
    icon: dominiosIcon,
    description: 'Crie, altere, exclua domínios para perguntas com múltiplas opções',
    route: '/consultar-dominio',
    area: 'formulario',
    funcionalidade: FuncionalidadesGeral.dominios.consultar,
  },
  {
    title: 'Perguntas',
    icon: perguntasIcon,
    description: 'Cadastre novos perguntas e consulte, altere e exclua perguntas existentes',
    route: '/consultar-pergunta',
    area: 'formulario',
    funcionalidade: FuncionalidadesGeral.perguntas.consultar,
  },
  {
    title: 'Seções',
    icon: secoesIcon,
    description: 'Crie, altere, exclua seções. Vincule também perguntas às seções',
    route: '/consultar-secao',
    area: 'formulario',
    funcionalidade: FuncionalidadesGeral.secoes.consultar,
  },
  {
    title: 'Formulários',
    icon: formularioIcon,
    description: 'Crie, consulte, modifique, associe, publique e exclua formulários',
    route: '/consultar-formulario',
    area: 'formulario',
    funcionalidade: FuncionalidadesGeral.formularios.consultar,
  },
  {
    title: 'Novo Atendimento Telefônico',
    icon: atendimentoPresencialIcon,
    description: 'Cadastre novo atendimento telefônico',
    route: '/cadastrar-atendimento?tipo=telefonico',
    area: 'atendimento',
    funcionalidade: FuncionalidadesGeral.atendimento.novoAtendimentoTelefonico,
  },
  {
    title: 'Novo Atendimento Presencial',
    icon: atendimentoTelefonicoIcon,
    description: 'Cadastre novo atendimento presencial',
    route: '/cadastrar-atendimento?tipo=presencial',
    area: 'atendimento',
    funcionalidade: FuncionalidadesGeral.atendimento.novoAtendimentoPresencial,
  },
]